import PropTypes from 'prop-types';
import { Box, TableCell, TableHead, TableRow, TableSortLabel, Typography } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { MHidden } from '../@material-extend';

const ListHead = ({ headLabel, onRequestSort, sortOrders, sortBy, ...other }) => {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead {...other}>
      <TableRow>
        {headLabel.map((headCell, key) => {
          const idx = sortBy?.findIndex((el) => el === headCell.id);

          return (
            <MHidden key={key} width={headCell.mHidden}>
              <TableCell
                key={headCell.id}
                align={headCell.align}
                sortDirection={idx >= 0 ? sortOrders[idx] : false}
                sx={{ borderTop: 0, verticalAlign: 'top' }}
              >
                <TableSortLabel
                  hideSortIcon
                  active={idx >= 0}
                  direction={idx >= 0 ? sortOrders[idx] : 'desc'}
                  onClick={createSortHandler(headCell.id)}
                >
                  <Typography variant="caption">{headCell.label}</Typography>
                  {idx >= 0 && (
                    <Box sx={{ ...visuallyHidden }}>
                      {sortOrders[idx] === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </Box>
                  )}
                </TableSortLabel>
              </TableCell>
            </MHidden>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

ListHead.propTypes = {
  headLabel: PropTypes.array,
  sortOrders: PropTypes.array,
  sortBy: PropTypes.array,
  onRequestSort: PropTypes.func
};

export default ListHead;
